import { Component, computed, inject, input } from '@angular/core';
import { ILpCanvasComponent, ILpCanvasElementContext } from '@gametailors/leerplus';
import { LpRidLocation, LpRidProvinceLabelCanvasComponent } from '../../../../typings/schema';
import { RidMapLabel, RidMapLabelState } from '../../components/rid-map-label/rid-map-label';
import { RidProgress } from '../../components/rid-progress-dot/rid-progress-dot';
import { RidJourneyService } from '../../services/rid-journey.service';

/** The name of a province on the overview map, with a dot per location showing how far its homework is. While the player chooses a province, the ones to choose from only show a question mark, so the name comes as the reward of choosing it. */
@Component({
  selector: 'rid-province-label-canvas-component',
  imports: [RidMapLabel],
  templateUrl: './rid-province-label-canvas-component.html',
  host: {
    class: 'grid size-full place-items-center',
  },
})
export class RidProvinceLabelCanvasComponent implements ILpCanvasComponent<LpRidProvinceLabelCanvasComponent> {
  private readonly $ridJourneyService = inject(RidJourneyService);

  comp = input.required<LpRidProvinceLabelCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  /** While choosing, the ones to choose from keep their name a mystery until they're chosen. */
  protected readonly labelState = computed<RidMapLabelState>(() => {
    const province = this.comp().province;
    if (this.$ridJourneyService.isProvinceLocked(province)) return 'LOCKED';

    if (this.$ridJourneyService.isProvinceExplored(province)) return 'FINISHED';

    return this.$ridJourneyService.isChoosingProvince() ? 'MYSTERY' : 'OPEN';
  });
  /** There's homework left there for today, so the player is called there. */
  protected readonly hasWorkToday = computed(() => this.$ridJourneyService.hasProvinceWorkToday(this.comp().province));
  protected readonly locationDots = computed(() =>
    this.$ridJourneyService.sortLocationsByStartOrder(this.comp().province.locations).map((location) => this.getLocationProgress(location)),
  );

  private getLocationProgress(location: LpRidLocation): RidProgress {
    if (this.$ridJourneyService.isLocationFinished(location)) return 'FINISHED';

    if (this.$ridJourneyService.isLocationInProgress(location)) return 'IN_PROGRESS';

    return 'NOT_STARTED';
  }
}
